import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ControlContainer from './forms/control_container';
import ReactTextareaAutosize from 'react-textarea-autosize';

/**
 * @visibleName Textarea Field
 */

const TextareaField = React.forwardRef((props, ref) => {
  const { 'data-aid': dataAid, description, error, label, success, onChange, value } = props;
  const [inputValue, setInputValue] = useState(value || '');

  const onInputChange = useCallback(
    ev => {
      const value = ev.target.value || '';
      setInputValue(value);
      onChange && onChange(value);
    },
    [onChange]
  );

  return (
    <FieldContained
      control={
        <StyledTextarea
          ref={ref}
          {...props}
          data-aid={dataAid}
          isError={!!error}
          onChange={onInputChange}
          value={inputValue}
        />
      }
      data-aid={dataAid}
      description={description}
      error={error}
      label={label}
      success={success}
    />
  );
});

TextareaField.propTypes = {
  'data-aid': PropTypes.string,
  autoFocus: PropTypes.bool,
  description: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  success: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const errorCss = css`
  border-color: ${p => p.theme.colors.red400};
  &:focus {
    border-color: ${p => p.theme.colors.red600};
  }
`;

export const FieldContained = styled(ControlContainer)`
  font-size: ${p => p.theme.fontSize.base};
`;

export const StyledTextarea = styled(({ isError, ...rest }) => <ReactTextareaAutosize {...rest} />)`
  background-color: ${p => p.theme.colors.white};
  border-radius: 8px;
  border: 1px solid ${p => p.theme.colors.gray300};
  flex: 1 1 auto;
  font-size: ${p => p.theme.fontSize.base};
  height: 32px;
  min-height: 100px;
  padding: 8px;
  resize: none;
  transition: border-color 100ms ease-in;
  width: 100%;

  &:focus {
    border-color: ${p => p.theme.colors.gray600};
  }
  transition: border-color 100ms ease-in;
  &[disabled] {
    background-color: ${p => p.theme.colors.gray100};
    color: ${p => p.theme.colors.gray500};
  }
  ${p => p.isError && errorCss};
`;

export default TextareaField;
